import React from "react";

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  alert(`Copied: ${text}`);
};

const handleVenmoClick = () => {
  // Try to open the Venmo app
  window.location.href = "venmo://paycharge?txn=pay&recipients=Veassna-Chan";
  // Fallback to web after 1.2s if the app isn't installed
  setTimeout(() => {
    window.open("https://venmo.com/Veassna-Chan", "_blank");
  }, 1200);
};

export default function DonationCards() {
  return (
    <section className="donation-section">
      {/* CashApp */}
      <div className="donation-card">
        <img src="/cashapp-qr.png" alt="CashApp QR" className="donation-qr" />
        <h3>CashApp</h3>
        <p>$VeassnaChan</p>
        <a
          href="https://cash.app/$VeassnaChan"
          target="_blank"
          rel="noopener noreferrer"
          className="donate-btn"
        >
          Open CashApp
        </a>
        <button className="copy-btn" onClick={() => copyToClipboard('$VeassnaChan')}>
          Copy CashApp
        </button>
      </div>
      {/* Venmo */}
      <div className="donation-card">
        <img src="/venmo-qr.png" alt="Venmo QR" className="donation-qr venmo-qr" />
        <h3>Venmo</h3>
        <p>@Veassna-Chan</p>
        <button
          className="donate-btn"
          onClick={handleVenmoClick}
          type="button"
        >
          Open Venmo
        </button>
        <button className="copy-btn" onClick={() => copyToClipboard('@Veassna-Chan')}>
          Copy Venmo
        </button>
      </div>
    </section>
  );
}
